import { LogLevel } from '@genesislcap/foundation-logger';
import { showDialog } from './dialog-launcher';
/**
 * Shows the notification dialog
 * @public
 */
export const showNotificationDialog = (configuration, tagName) => {
    if (!configuration.title) {
        throw new Error('Title is required');
    }
    if (!configuration.body) {
        throw new Error(`Missing required param 'body'`);
    }
    let notificationStructure = {
        title: configuration.title,
        body: configuration.body,
    };
    let config = {};
    if (configuration.logLevel in LogLevel) {
        notificationStructure = Object.assign({ logLevel: configuration.logLevel }, notificationStructure);
    }
    if (configuration.dialog) {
        config = Object.assign({ dialog: configuration.dialog }, config);
        notificationStructure = Object.assign({ config }, notificationStructure);
    }
    showDialog(notificationStructure, tagName);
};
